import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, map, catchError, filter, flatMap } from 'rxjs/operators';
import { LOCATION_CHANGE, replace } from 'connected-react-router';
import { matchPath } from 'react-router-dom';
import { combineEpics } from 'web-app/util/redux-observable';
import DayCareApi from 'signin-app/api/daycare-api';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { getRestClientErrorMessage } from 'signin-app/api/clients/get-rest-client-error-message';
import { defaultErrorDuration } from 'web-app/react/global-event/helpers/constants';
import RoutesMap from 'signin-app/routes/routes-map';
import { fetchOverview, fetchOverviewSuccess, fetchOverviewFailed } from 'signin-app/groups/actions';
import { checkInChildSuccess, resetPickup } from 'signin-app/child/check-in/actions';
import { checkOutChildSuccess } from 'signin-app/child/check-out/actions';
import { checkInEmployeeSuccess } from 'signin-app/employee/check-in/actions';
import { checkOutEmployeeSuccess } from 'signin-app/employee/check-out/actions';
import * as LoginSelectors from 'signin-app/login/selectors';
import { isCompletelyLoggedIn } from 'signin-app/pin/selectors';
import { nextPersonUrl } from 'signin-app/child/selectors';
import * as Actions from './actions';
const pinLogin = action$ => action$.pipe(ofType(Actions.pinLogin.type), mergeMap(({ payload }) => DayCareApi.pinLogin(payload.pin).pipe(map(response => {
    return Actions.pinLoginSuccess.action(response);
}), catchError(e => {
    dispatchStatusMessageEvent({
        message: getRestClientErrorMessage(e),
        statusType: 'Error',
        sticky: false,
        e2eId: '',
        duration: defaultErrorDuration,
    });
    return of(Actions.pinLoginFailed.action(e));
}))));
const institutionOverview = action$ => action$.pipe(ofType(fetchOverview.type), mergeMap(({ payload }) => DayCareApi.groups(payload.accessToken).pipe(map(overview => fetchOverviewSuccess.action(overview)), catchError(e => {
    dispatchStatusMessageEvent({
        message: getRestClientErrorMessage(e),
        statusType: 'Error',
        sticky: false,
        e2eId: '',
        duration: defaultErrorDuration,
    });
    return of(fetchOverviewFailed.action());
}))));
const clearPin = (action$, state$) => action$.pipe(ofType(LOCATION_CHANGE), filter(({ payload }) => {
    const isLoggedIn = isCompletelyLoggedIn(state$.value);
    return payload.location.pathname === RoutesMap.pin && isLoggedIn;
}), map(() => {
    return Actions.pinLogout.action();
}));
const redirectOnSuccess = (action$, state$) => action$.pipe(ofType(checkInChildSuccess.type, checkOutChildSuccess.type, checkInEmployeeSuccess.type, checkOutEmployeeSuccess.type), 
// The newer screens for a room's child and for staff show their own confirmation, then go back
filter(() => !matchPath(state$.value.router.location.pathname, {
    path: [RoutesMap.selectChildInRoom, RoutesMap.selectStaff],
})), flatMap(action => {
    const pinApp = LoginSelectors.isPinApp(state$.value);
    const pinRedirectUrl = nextPersonUrl(state$.value, action.payload.response);
    const redirectToUrl = pinApp ? pinRedirectUrl : RoutesMap.overview;
    const actions = [replace(redirectToUrl)];
    return actions;
}));
const updateChildOnSuccess = (action$, state$) => action$.pipe(ofType(checkInChildSuccess.type, checkOutChildSuccess.type), filter(() => LoginSelectors.isPinApp(state$.value)), flatMap(({ payload }) => {
    // child-checkout endpoint returns an array
    const childPayload = Array.isArray(payload) ? payload[0] : payload;
    return [resetPickup.action(), Actions.updateChild.action(childPayload)];
}));
const updateEmployeeOnSuccess = (action$, state$) => action$.pipe(ofType(checkInEmployeeSuccess.type, checkOutEmployeeSuccess.type), filter(() => LoginSelectors.isPinApp(state$.value)), flatMap(({ payload }) => {
    return [Actions.updateEmployee.action(payload)];
}));
export default combineEpics(pinLogin, institutionOverview, clearPin, redirectOnSuccess, updateChildOnSuccess, updateEmployeeOnSuccess);
